import apiStatus from "../_helpers/apiStatus";

class AuthService {
  constructor(NetworkService, $state) {
    'ngInject';
    this.state = $state;
    this.networkService = NetworkService;
  }

  getSessionInfo(callback) {
    this.networkService.execute('GET', '/common/user/session', null, (result) => {
      //alert(JSON.stringify(result))
      if (result.apiStatus === apiStatus.SUCCESS) {
        if(result.data.redirectUrl) {
          window.location = result.data.redirectUrl;
        } else {
          //set the userdata in session so I can access later
          sessionStorage.setItem('userData', JSON.stringify(result.data));
        }
      }
      callback(result);
    });
  }

  getUserRoles() {
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    return userData ? userData.roleIdList : [];
  }

  getAppAccess() {
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    return userData ? userData.applicationList : [];
  }


  getUserFirstName() {
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    return userData && userData.firstName ? userData.firstName : " ";
  }

  checkAuthenticated(callback) {
    let userData = sessionStorage.getItem('userData');

    if(!userData) {
      //I don't have user data now (might be a new tab)
      //although the session cookie may still be valid
      //So try to get session data from the session cookie
      //If the session cookie is not valid, this call will redirect to login
      this.getSessionInfo(() => {
        //only need to call the callback function.  This callback will only be called if the session is valid
        callback();
      });
    }

    //authenticated if user data is not null, although session might be invalid
    //The next call to the server will return INVALID_SESSION and redirect to login
    return userData !== null;
  }

  hasUserRole(requiredRoleId) {
    let userRoles = this.getUserRoles();
    if(!userRoles) {
      return false;
    }
    return userRoles.find(x => x === requiredRoleId) !== undefined
  }

  login(username, password, callback) {
    let data = {username: username, password: password};
    this.networkService.execute('POST', '/login', data, callback);
  }

  forgotPassword(emailId, callback) {
    let data = {emailId: emailId}
    this.networkService.execute('POST', '/forgot/password', data, callback);
  }

  //Common functions below
  getUserProfile(callback) {
    this.networkService.execute('GET', '/common/user/profile', null, callback);
  }

  updateUserProfile(profile, callback) {
    this.networkService.execute('PUT', '/common/user/profile', profile, callback);
  }

  resetPassword(token, password, callback) {
    let data = {password: password, token: token}
    this.networkService.execute('PUT', '/common/password', data, callback);
  }

  resetPasswordForUser(userId, password, callback) {
    let data = {id: userId, password: password}
    this.networkService.execute('PUT', '/common/password', data, callback);
  }

  logout() {
    this.networkService.execute('DELETE', '/common/login', {}, () => {
      sessionStorage.clear();
      this.state.go("auth.login")
    });
  }

}

export default AuthService;



// WEBPACK FOOTER //
// ./client/app/_services/auth.service.js